import map from 'lodash/map'
import split from 'lodash/split'
import trim from 'lodash/trim'

export type LatLng = {
  lat: number
  lng: number
}

export const parseGeoLocation = (
  geolocation?: string | null
): LatLng | null => {
  if (!geolocation) return null
  geolocation = trim(geolocation, '(')
  geolocation = trim(geolocation, ')')
  const partsAsStrings = split(geolocation, ',')
  const partsAsNumbers = map(partsAsStrings, (p) => +p)
  const [lat, lng] = partsAsNumbers
  return { lat, lng }
}
